import { router } from '@inertiajs/react'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'

interface PagyData {
  page: number
  pages: number
  count: number
  next: number | null
  prev: number | null
}

interface PagyPaginationProps {
  pagy: PagyData
}

export default function PagyPagination({ pagy }: PagyPaginationProps) {
  if (pagy.pages <= 1) return null

  function navigateTo(e: React.MouseEvent, page: number) {
    e.preventDefault()
    const url = new URL(window.location.href)
    url.searchParams.set('page', String(page))
    router.get(url.pathname + url.search, {}, { preserveState: true })
  }

  return (
    <div className="flex items-center justify-between border-t px-6 py-3">
      <p className="text-xs text-muted-foreground">
        Page {pagy.page} of {pagy.pages} ({pagy.count} total)
      </p>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              href="#"
              onClick={(e) => pagy.prev && navigateTo(e, pagy.prev)}
              className={pagy.prev ? 'cursor-pointer' : 'pointer-events-none opacity-50'}
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              href="#"
              onClick={(e) => pagy.next && navigateTo(e, pagy.next)}
              className={pagy.next ? 'cursor-pointer' : 'pointer-events-none opacity-50'}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )
}
